let _show = null;

export const registerSnackbar = (fn) => { _show = fn; };

export const snackbar = {
  success: (msg) => _show?.(msg, 'success'),
  error:   (msg) => _show?.(msg, 'error'),
  info:    (msg) => _show?.(msg, 'info'),
  warning: (msg) => _show?.(msg, 'warning'),
};
